// Swiper Slider JavaScript (Collection & Testimonials)
class SwiperSlider {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.init();
  }

  init() {
    if (!this.element) return;

    // Check for mobile grid mode
    const mobileGridMode = this.element.getAttribute("data-mobile-grid-mode") === "true";
    const isMobile = window.innerWidth < 750;

    // Skip Swiper initialization on mobile if grid mode is enabled
    if (mobileGridMode && isMobile) {
      console.log("Mobile grid mode enabled, skipping Swiper initialization");
      // Listen for resize in case user rotates to tablet/desktop
      window.addEventListener("resize", () => {
        const isNowMobile = window.innerWidth < 750;
        if (!isNowMobile && !this.swiper) {
          // Now on tablet/desktop, initialize Swiper
          this.initSwiper();
        } else if (isNowMobile && this.swiper) {
          // Back to mobile, destroy Swiper
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      });
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    // Check if Swiper is available
    if (typeof Swiper === "undefined") {
      console.warn("Swiper library not loaded yet, retrying...");
      setTimeout(() => this.initSwiper(), 100);
      return;
    }

    try {
      const config = JSON.parse(
        this.element.getAttribute("data-swiper-config")
      );

      // Initialize Swiper
      this.swiper = new Swiper(this.element, config);

      // Handle responsive pagination
      this.updatePagination();

      // Update on resize
      window.addEventListener("resize", () => this.updatePagination());
    } catch (error) {
      console.error("Error initializing Swiper:", error);
    }
  }

  updatePagination() {
    if (!this.swiper || !this.swiper.pagination) return;

    const isMobile = window.innerWidth < 750;
    const sectionId = this.element.classList[1].replace(
      /^(collection-swiper-|testimonials-swiper-|social-posts-swiper-)/,
      ""
    );

    // Check if it's a collection slider, testimonials slider, or social posts slider
    const isCollectionSlider =
      this.element.classList[1].includes("collection-swiper-");
    const isTestimonialsSlider = this.element.classList[1].includes(
      "testimonials-swiper-"
    );
    const isSocialPostsSlider = this.element.classList[1].includes(
      "social-posts-swiper-"
    );
    const isInstagramReelsSlider = this.element.classList[1].includes(
      "instagram-reels-swiper-"
    );

    let shouldShowPagination = false;

    if (isCollectionSlider) {
      shouldShowPagination = isMobile
        ? window.collectionSliderSettings?.[sectionId]?.showPaginationMobile
        : window.collectionSliderSettings?.[sectionId]?.showPaginationDesktop;
    } else if (isTestimonialsSlider) {
      shouldShowPagination = isMobile
        ? window.testimonialsSliderSettings?.[sectionId]?.showPaginationMobile
        : window.testimonialsSliderSettings?.[sectionId]?.showPaginationDesktop;
    } else if (isSocialPostsSlider) {
      shouldShowPagination = isMobile
        ? window.socialPostsSliderSettings?.[sectionId]?.showPaginationMobile
        : window.socialPostsSliderSettings?.[sectionId]?.showPaginationDesktop;
    } else if (isInstagramReelsSlider) {
      shouldShowPagination = isMobile
        ? window.instagramReelsSliderSettings?.[sectionId]?.showPaginationMobile
        : window.instagramReelsSliderSettings?.[sectionId]?.showPaginationDesktop;
    }

    if (shouldShowPagination) {
      this.swiper.pagination.enable();
      this.swiper.pagination.render();
      this.swiper.pagination.update();
    } else {
      this.swiper.pagination.disable();
    }
  }
}

// Initialize all swiper sliders when DOM is ready
function initializeSliders() {
  // Prevent duplicate initialization
  if (window.slidersInitialized) return;
  window.slidersInitialized = true;

  // Store settings globally for access
  window.collectionSliderSettings = {};
  window.testimonialsSliderSettings = {};
  window.socialPostsSliderSettings = {};
  window.instagramReelsSliderSettings = {};

  // Find all collection slider elements
  const collectionSliderElements = document.querySelectorAll(
    '[class*="collection-swiper-"]'
  );

  collectionSliderElements.forEach((element) => {
    const sectionId = element.classList[1].replace("collection-swiper-", "");

    // Store settings for this section
    window.collectionSliderSettings[sectionId] = {
      showPaginationMobile: element.dataset.showPaginationMobile === "true",
      showPaginationDesktop: element.dataset.showPaginationDesktop === "true",
    };

    // Initialize slider
    new SwiperSlider(element);
  });

  // Find all testimonials slider elements
  const testimonialsSliderElements = document.querySelectorAll(
    '[class*="testimonials-swiper-"]'
  );

  testimonialsSliderElements.forEach((element) => {
    const sectionId = element.classList[1].replace("testimonials-swiper-", "");

    // Store settings for this section
    window.testimonialsSliderSettings[sectionId] = {
      showPaginationMobile: element.dataset.showPaginationMobile === "true",
      showPaginationDesktop: element.dataset.showPaginationDesktop === "true",
    };

    // Initialize slider
    new SwiperSlider(element);
  });

  // Find all social posts slider elements
  const socialPostsSliderElements = document.querySelectorAll(
    '[class*="social-posts-swiper-"]'
  );

  socialPostsSliderElements.forEach((element) => {
    const sectionId = element.classList[1].replace("social-posts-swiper-", "");

    // Store settings for this section
    window.socialPostsSliderSettings[sectionId] = {
      showPaginationMobile: element.dataset.showPaginationMobile === "true",
      showPaginationDesktop: element.dataset.showPaginationDesktop === "true",
    };

    // Initialize slider
    new SwiperSlider(element);
  });

  // Find all instagram reels slider elements
  const instagramReelsSliderElements = document.querySelectorAll(
    '[class*="instagram-reels-swiper-"]'
  );

  instagramReelsSliderElements.forEach((element) => {
    const sectionId = element.classList[1].replace("instagram-reels-swiper-", "");

    // Store settings for this section
    window.instagramReelsSliderSettings[sectionId] = {
      showPaginationMobile: element.dataset.showPaginationMobile === "true",
      showPaginationDesktop: element.dataset.showPaginationDesktop === "true",
    };

    // Initialize slider
    new SwiperSlider(element);
  });
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initializeSliders);

// Also initialize when window loads (fallback)
window.addEventListener("load", function () {
  // Small delay to ensure everything is loaded
  setTimeout(initializeSliders, 100);
});

// Initialize if DOM is already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeSliders);
} else {
  // DOM is already loaded
  setTimeout(initializeSliders, 100);
}
